import { NavLink } from "react-router-dom";
import { LayoutDashboard, ListChecks, Layers, MousePointerClick, LogOut } from "lucide-react";

const items = [
  { to: "/admin/dashboard", label: "Overview", icon: LayoutDashboard, testId: "nav-overview" },
  { to: "/admin/qa", label: "QA Searches", icon: ListChecks, testId: "nav-qa" },
  { to: "/admin/queue", label: "Review Queue", icon: Layers, testId: "nav-queue" },
  { to: "/admin/affiliate", label: "Affiliate", icon: MousePointerClick, testId: "nav-affiliate" },
];

export const AdminNav = ({ onLogout }) => (
  <div className="flex items-center justify-between mb-7 gap-3 flex-wrap">
    <div className="inline-flex bg-card border border-border rounded-xl p-1 gap-1">
      {items.map(({ to, label, icon: Icon, testId }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={testId}
          className={({ isActive }) =>
            `flex items-center gap-1.5 text-xs px-3 py-2 rounded-lg transition ${
              isActive
                ? "bg-emerald-500/15 text-emerald-400 border border-emerald-500/30"
                : "text-muted-foreground hover:text-foreground hover:bg-secondary border border-transparent"
            }`
          }
        >
          <Icon className="w-3.5 h-3.5" />
          {label}
        </NavLink>
      ))}
    </div>
    {onLogout && (
      <button
        onClick={onLogout}
        data-testid="admin-logout-btn"
        className="flex items-center gap-1.5 text-xs px-3 py-2 rounded-lg border border-border hover:bg-secondary transition"
      >
        <LogOut className="w-3.5 h-3.5" />
        Sign out
      </button>
    )}
  </div>
);

export default AdminNav;
